
import React from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { Send } from "lucide-react";
import { FormInputField } from "./FormField";
import { CheckboxField } from "./CheckboxField";
import { formSchema, useContactFormSubmit, type ContactFormValues } from "@/hooks/use-contact-form-submit";

const ContactForm = () => {
  const form = useForm<ContactFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
      email: "",
      message: "",
      interested_in_early_access: false,
      interested_in_investment: false,
      interested_in_team: false,
    },
  });
  
  const { isSubmitting } = form.formState;
  const submitForm = useContactFormSubmit(form);
  const onSubmit = (values: ContactFormValues) => submitForm(values);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormInputField
          form={form}
          name="name"
          label="Name"
          placeholder="Your name"
          disabled={isSubmitting}
        />
        
        <FormInputField
          form={form}
          name="email"
          label="Email"
          placeholder="your.email@example.com"
          type="email"
          disabled={isSubmitting}
        />
        
        <FormInputField
          form={form}
          name="message"
          label="Message"
          placeholder="Your message..."
          type="textarea"
          disabled={isSubmitting}
        />

        <div className="space-y-4">
          <h3 className="text-lg font-medium">I'm interested in:</h3>
          
          <CheckboxField
            form={form}
            name="interested_in_early_access"
            label="Early Access"
          />
          
          <CheckboxField
            form={form}
            name="interested_in_investment"
            label="Investment Opportunities"
          />
          
          <CheckboxField
            form={form}
            name="interested_in_team"
            label="Joining the Team"
          />
        </div>
        
        <Button 
          type="submit" 
          disabled={isSubmitting}
          className="w-full sm:w-auto bg-morgen-gradient hover:opacity-90"
        >
          {isSubmitting ? (
            <>Sending...</>
          ) : (
            <>
              <Send className="mr-2" />
              Send Message
            </>
          )}
        </Button>
      </form>
    </Form>
  );
};

export default ContactForm;
